import swal from 'sweetalert';

export default {
    error: (text, showIcon = true) => swal(text, {icon: showIcon ? 'error' : '', buttons: [false, '确定']}),
    succ: text => swal(text, {icon: 'success', buttons: [false, '确定']}),
    swal: (...args) => swal(...args),
    noAccess () {
        this.error('您无此操作权限，请咨询小猴编程老师！');
    },
    swalAgent (
        err,
        defaultText,
        options
    ) {
        if (
            typeof err === 'object' &&
            err.status === 401
        ) return;
        const {
            data = {}, message, statusText, status
        } = err;
        const msg = message || data.message || (status + ': ' + statusText);
        let msgs = defaultText ? defaultText : '';
        if (msg) msgs += ' 错误信息：' + msg;
        return swal(
            msgs,
            {icon: 'error', buttons: [false, '确定'], ...options}
        );
    }
};
